import { defineComponent, nextTick } from "vue";
import OrderLayout from "../../layouts/OrderLayout";
import FormInfo from "../../components/FormInfo";
import Utils from "../../utils/Utils";
import Tracking from "../../utils/Tracking";
import UploadInfoBar from "../../components/UploadInfoBar";

export default defineComponent({
    components: {
        OrderLayout,
        FormInfo,
        UploadInfoBar,
    },

    template: `
        <OrderLayout class="StepVerify" :options="options" :step="1" title="Wow! To było szybkie<br>Sprawdź, czy wszystko się zgadza" :wrapper="932" :summarycollapsed="false" @offer:change="$emit('back')">
            <div class="contentbox">
                <UploadInfoBar
                    :options="options"
                    @change="$emit('invoice:change')"
                />

                <hr class="StepVerify_hr1">

                <h2>Informacje o taryfie</h2>
                <FormInfo title="Deklarowane zużycie" :value="usage" />
                <FormInfo title="Taryfa" :value="options.tariff" />
                <FormInfo title="Okres rozliczeniowy" :value="period" />
                <FormInfo title="Okres wypowiedzenia umowy" :value="noticeperiod" />
                <FormInfo title="Rezerwowy sprzedawca energii" :value="sparevendor" />

                <hr>

                <h2>Punkt Poboru Energii</h2>
                <FormInfo title="Dotychczasowy sprzedawca" :value="prevvendor" />
                <FormInfo title="Operator Sieci (OSD)" :value="osd" />
                <FormInfo title="Numer PPE (Punkt Poboru Energii)" :value="options.ppe" />
                <FormInfo title="Ulica" :value="address(options.ppe_street, options.ppe_buildingno, options.apartmentno)" />
                <FormInfo title="Kod pocztowy" :value="options.ppe_zipcode" />
                <FormInfo title="Miejscowość" :value="options.ppe_city" />

                <hr>

                <h2>Dane do umowy</h2>

                <FormInfo title="Imię" :value="options.billing_firstname" />
                <FormInfo title="Nazwisko" :value="options.billing_lastname" />
                <FormInfo title="Ulica" :value="address(options.billing_street, options.billing_buildingno, options.billing_apartmentno)" />
                <FormInfo title="Kod pocztowy" :value="options.billing_zipcode" />
                <FormInfo title="Miejscowość" :value="options.billing_city" />

                <template v-if="options.other_active">
                    <hr>

                    <h2>Adres do korespondencji</h2>

                    <FormInfo title="Ulica" :value="address(options.other_street, options.other_buildingno, options.other_apartmentno)" />
                    <FormInfo title="Kod pocztowy" :value="options.other_zipcode" />
                    <FormInfo title="Miejscowość" :value="options.other_city" />
                </template>

                <div class="StepVerify__buttons">
                    <button type="button" class="button button--primary button--full" @click="onNext('accept')">Potwierdź i przejdź dalej</button>
                    <button type="button" class="button button--secondary button--full" @click="onNext('edit')">Edytuj dane</button>
                </div>
            </div>
        </OrderLayout>
    `,

    emits: [
        'accept',
        'edit',
        'back',
        'invoice:change',
    ],

    props: {
        /** @var OrderJson */
        options: { type: Object, required: true },
    },

    computed: {
        period() {
            return this.options.period ? Utils.yearsTitle(this.options.period) : 'nieoznaczony';
        },

        noticeperiod() {
            return Utils.monthsTitle(this.options.noticeperiod ?? 1);
        },

        osd() {
            return (<any[]>this.options.si_osds).find(v => v.id == this.options.osd)?.label;
        },

        prevvendor() {
            return (<any[]>this.options.si_vendors).find(v => v.id == this.options.prev_vendor)?.label;
        },

        sparevendor() {
            if (!this.options.spare_vendor) {
                return 'Ustawowy';
            }

            return (<any[]>this.options.si_vendors).find(v => v.id == this.options.spare_vendor)?.label;
        },

        usage() {
            return this.options.usage + ' kWh / rok';
        },
    },

    async mounted() {
        await Tracking.doEvent('invoiceupload_success', {
            mail: this.options.email,
            phone: this.options.phone,
        });

        nextTick(() => {
            Utils.scrollToEl($('.StepVerify'));
        });
    },

    methods: {
        address(street: string, buildingno: string, apartmentno: string): string {
            return street + ' ' + buildingno + (apartmentno ? '/' + apartmentno : '');
        },

        async onNext(action: string) {
            await Utils.setCart('accept-info', {
                accept: action == 'accept',
            });

            if (action == 'accept') {
                this.$emit('accept');
            } else {
                this.$emit('edit');
            }
        },
    },
});
